/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Box } from '@material-ui/core';
import { result } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { ResultTableHead } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/utilities';
import { getNDCPaymentResultGrid } from '../Store/actions';

export default function DispNDCPayment() {
  const dispatch = useDispatch();
  const [filteredRows, setFilteredRow] = React.useState([]);
  const {
    isLoading,
    rebateProgramValue,
    rebateProgramList,
    searchResult,
    rebateProgramName,
    quarterValue,
    selectedPlanType,
    rebateProgrameName,
  } = useSelector((state) => state?.sharedState?.NDCPaymentReducer);
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;
  const [resultList, setResultList] = React.useState([]);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const fromDate = convertStringDate(quarterToDate(quarterValue));
  const toDate = convertStringDate(quarterToDate(quarterValue, 'toDate'));

  // API call for Grid
  // React.useEffect(() => {
  //   dispatch(
  //     getNDCPaymentResultGrid({
  //       startDate: convertStringDate(quarterToDate(quarterValue)),
  //       endDate: convertStringDate(quarterToDate(quarterValue, 'toDate')),
  //       rebateProgram: rebateProgramValue,
  //       quarter: quarterValue,
  //     })
  //   );
  // }, []);

  React.useEffect(() => {
    let updatedSearchResult = searchResult || [];
    updatedSearchResult = updatedSearchResult.map((item) => {
      const ndcValue = `${item.lablerCode} - ${item.productCode} - ${item.packageSize}`;
      return {
        ...item,
        ndc: ndcValue,
        paidAmt: item.paidAmt === null ? '0.00' : item.paidAmt,
      };
    });
    setResultList(updatedSearchResult);
  }, [searchResult]);

  // Function to add the rows
  const sum = (property) => {
    // const displayedRows = resultList;
    const displayedRows = filteredRows.length > 0 ? filteredRows : resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : '0.00';
  };

  // columns to show total
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        ndc: 'Total',
        noOfUnits: parseFloat(sum('noOfUnits')).toFixed(4),
        paidAmt: sum('paidAmt'),
      });
    }
    return result;
  };

  const onFilterChanged = (rowData, type) => {
    const updatedRowData =
      rowData &&
      rowData.map((item) => {
        return {
          ...item,
          // paidAmt: parseFloat(item.paidAmt.replace('$', '').replace(/,/g, '')),
        };
      });
    setFilteredRow(updatedRowData);
  };

  // To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [resultList, filteredRows]);

  // PDF header
  const firstInfo = `Quarter : ${quarterValue}`;
  const secondInfo = `${fromDate} - ${toDate}`;
  const thirdInfo = rebateProgramNameValue;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <div className="tab-body">
          <CustomSeparator
            parent1="State Reports"
            parent2="Display NDC Payment"
          />
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-2">
              <div className="col-4">
                <TextField
                  label="Rebate Program: "
                  id="rebateProgram"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={rebateProgramNameValue}
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-4">
                <TextField
                  label="Quarter"
                  id="quarter"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={quarterValue}
                  name="quarter"
                  disabled
                />
              </div>
              <div className="col-4">
                <TextField
                  label="Payment Received"
                  id="paymentReceived"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={`${fromDate} - ${toDate}`}
                  name="paymentReceived"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGridWithFeatures
        rowData={
          (resultList &&
            resultList.map((item) => {
              return {
                ...item,
                paidAmt: item.paidAmt ? item.paidAmt : '0.00',
                noOfUnits: item.noOfUnits
                  ? item.noOfUnits.toFixed(4)
                  : '0.0000',
              };
            })) ||
          []
        }
        columnDefs={ResultTableHead}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,

          autoHeaderHeight: true,
        }}
        hideTotalCount={false}
        exportFile
        fileName="NDCPAYMENT"
        reportName="NDC payment Detail Report"
        isScrollOn
        defaultColWidth={200}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        onFilterData={onFilterChanged}
        pinnedBottomRowData={pinnedBottomRowData}
        info={{ firstInfo, secondInfo, thirdInfo }}
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 27) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
      />
    </div>
  );
}
